import { PaginatedResponse } from "@intentsify/types";
import { apiService, Endpoints } from "api";
import {
  QuantumDemandDomainMeta,
  QuantumDemandFetchDataParams,
  QuantumDemandRow,
} from "./QuantumDemand.types";
import { QuantumDemandContact } from "./components/QuantumDemandContactCard";

export const listPaginatedQuantumDemand = async (
  campaignId: number,
  params: QuantumDemandFetchDataParams,
): Promise<PaginatedResponse<QuantumDemandRow>> => {
  const { page, per_page, search, order, order_by, domains } = params;

  const { data } = await apiService.post(
    Endpoints.Campaigns.Post.QuantumDemand.Paginated(campaignId),
    {
      page,
      per_page,
      search,
      order,
      order_by,
      domains,
    },
  );

  return data;
};

export const getQuantumDemandDomainContacts = async (
  campaignId: number,
  domain: string,
): Promise<QuantumDemandContact[]> => {
  const { data } = await apiService.get<QuantumDemandContact[]>(
    Endpoints.Campaigns.Get.QuantumDemand.DomainContacts(campaignId),
    {
      params: { domain },
    },
  );

  return data;
};

export const getQuantumDemandDomainMeta = async (
  campaignId: number,
  domain: string,
): Promise<QuantumDemandDomainMeta | null> => {
  const { data } = await apiService.get<QuantumDemandDomainMeta | null>(
    Endpoints.Campaigns.Get.QuantumDemand.DomainMeta(campaignId),
    {
      params: { domain },
    },
  );

  return data;
};
